import React from "react";
import { useNavigate } from "react-router-dom";

const UpcomingEvents = ({ events, isMobile }) => {
  const navigate = useNavigate();

  const handleEventClick = (path) => navigate(path);

  return (
    <div
      style={{
        padding: isMobile ? "20px 16px" : "0 24px",
        maxWidth: "100%",
        margin: "0 auto",
        backgroundColor: "#F7F7F7",
        borderRadius: "0px",
        paddingTop: isMobile ? "20px" : "30px",
        paddingBottom: isMobile ? "20px" : "30px",
      }}
    >
      <h2
        style={{
          fontSize: isMobile ? "20px" : "28px",
          fontWeight: "700",
          color: "#000",
          marginBottom: isMobile ? "16px" : "20px",
          textAlign: "left",
        }}
      >
        Upcoming Events
      </h2>

      <EventsGrid 
        events={events} 
        isMobile={isMobile} 
        onEventClick={handleEventClick} 
      />
    </div>
  );
};

const EventsGrid = ({ events, isMobile, onEventClick }) => {
  if (isMobile) {
    return (
      <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
        {events.map((event, idx) => (
          <EventTile 
            key={idx} 
            event={event} 
            isMobile={isMobile} 
            onClick={onEventClick} 
          />
        ))}
      </div>
    );
  }

  return (
    <div style={{ display: "flex", gap: "20px", justifyContent: "space-between", flexWrap: "nowrap" }}>
      {events.map((event, idx) => (
        <EventTile 
          key={idx} 
          event={event} 
          isMobile={isMobile} 
          onClick={onEventClick} 
        />
      ))}
    </div>
  );
};

const EventTile = ({ event, isMobile, onClick }) => (
  <div
    className={isMobile ? "mobile-news-tile" : "news-tile"}
    style={{
      ...(isMobile ? {
        textAlign: "left",
        overflow: "hidden",
        cursor: "pointer",
        backgroundColor: "#fff",
        borderRadius: "12px",
        padding: "12px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        transition: "all 0.3s ease",
      } : {
        flex: "1 1 0",
        textAlign: "left",
        overflow: "hidden",
        cursor: "pointer",
        borderRadius: "12px",
        backgroundColor: "#fff",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        transition: "all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
        position: "relative",
      }),
    }}
    onClick={() => onClick(event.path)}
  >
    <div className={isMobile ? "mobile-news-image-container" : "news-image-container"}>
      <img
        src={event.img}
        alt={event.name}
        className={isMobile ? "mobile-news-image" : "news-image"}
        style={{
          width: "100%",
          height: isMobile ? "140px" : "200px",
          objectFit: "cover",
          marginBottom: isMobile ? "10px" : "12px",
          borderRadius: isMobile ? "8px" : "0px",
          transition: "all 0.3s ease",
        }}
      />
      {!isMobile && <div className="news-overlay" />}
    </div>
    <div style={{ padding: isMobile ? "0" : "0 16px 16px" }}>
      <p
        style={{
          color: "#373737",
          fontSize: isMobile ? "13px" : "16px",
          lineHeight: "1.4",
          margin: 0,
        }}
      >
        {event.text}
      </p>
    </div>
  </div>
);

export default UpcomingEvents;